import React from "react";
import { Link } from "react-router-dom";
import "../styles/styles.css";

const SeriesCard = ({ series }) => (
  <Link to={`/series/${series.id}`} className="series-card">
    <div
      className="series-thumb"
      style={{ backgroundImage: `url(${series.thumbnail})` }}
    >
      <div className="series-thumb-overlay" />
      <div className="series-title-hover">{series.title}</div>
    </div>
    <div className="series-info">
      <h3 className="series-title">{series.title}</h3>
      <p className="series-genre">{series.genre.join(", ")}</p>
      <p className="series-release">Estreno: {series.releaseDate}</p>
    </div>
  </Link>
);

export default SeriesCard;